// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users_header_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  height: 50px;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border);
  margin-bottom: 30px;
}

.users_count_div{
  display: flex;
  align-items: center;
  background-color: var(--bg);
  color: var(--primary);
  padding: 3px 10px;
  border-radius: 5px;
}

.agbk_userData_kyc {
  width: 40%;
  background-color: var(--bg-card);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.agbk_userData_chiffres_user {
  width: 60%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-card);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.agbk_userData_chiffres {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.agbk_userData_multi_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ago/AgoUser/agoUser.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;AACX","sourcesContent":[".users_header_box{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0px;\n  height: 50px;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 30px;\n}\n\n.users_count_div{\n  display: flex;\n  align-items: center;\n  background-color: var(--bg);\n  color: var(--primary);\n  padding: 3px 10px;\n  border-radius: 5px;\n}\n\n.agbk_userData_kyc {\n  width: 40%;\n  background-color: var(--bg-card);\n  padding: 20px;\n  border-radius: 15px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.agbk_userData_chiffres_user {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-card);\n  padding: 20px;\n  border-radius: 15px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.agbk_userData_chiffres {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.agbk_userData_multi_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n  gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
